import React from 'react';
import { Search } from 'lucide-react';

export const SucheFeld = ({ value, onChange, testId, placeholder = 'Suchen: Mandanten-Nr., Name, E-Mail, AZ …' }) => (
  <label className="flex items-center gap-2 bg-white border border-gray-200 rounded-sm px-3 py-1.5 w-full sm:w-72 focus-within:border-[#b8893d]">
    <Search className="w-3.5 h-3.5 text-[#7a8a99]" />
    <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} className="flex-1 min-w-0 text-xs focus:outline-none" />
  </label>
);
